import { ButtonIcon, TextLeftIcon, TextMiddleIcon, TextRightIcon, Tooltip } from 'canoe';
import omit from 'lodash/omit';
import React from 'react';
import { Editor, Transforms } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

import { SlateNode } from 'craft/types';

interface TextAlignmentButtonsProps {
  disabled?: boolean;
}

export const TextAlignmentButtons: React.FC<TextAlignmentButtonsProps> = ({
  disabled,
}: TextAlignmentButtonsProps) => {
  const rteEditor = useSlate() as ReactEditor;

  if (!rteEditor.selection) {
    return null;
  }

  const [match] = Array.from(
    Editor.nodes(rteEditor, {
      at: Editor.unhangRange(rteEditor, rteEditor.selection),
      match: (n: SlateNode) => n?.data?.variant,
    }),
  );
  const node = match?.[0] as SlateNode | undefined;

  const css = node?.data?.css || {};

  const toggleValues = (prop: Record<string, unknown>) => {
    const [[key, value]] = Object.entries(prop);
    const shouldRemoveValue = css[key] === value;

    Transforms.setNodes(
      rteEditor,
      {
        data: {
          ...(node?.data || {}),
          css: shouldRemoveValue ? omit(css || {}, key) : { ...(css || {}), [key]: value },
        },
      },
      {
        at: rteEditor.selection ? Editor.unhangRange(rteEditor, rteEditor.selection) : [],
        match: (n: SlateNode) => n?.data?.variant,
      },
    );
  };

  return (
    <>
      <Tooltip offset="xxs" placement="top" content="Align Left">
        <ButtonIcon
          disabled={disabled}
          size="small"
          icon={TextLeftIcon}
          active={css.textAlign === 'left'}
          onClick={() => toggleValues({ textAlign: 'left' })}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip offset="xxs" placement="top" content="Align Center">
        <ButtonIcon
          disabled={disabled}
          size="small"
          icon={TextMiddleIcon}
          active={css.textAlign === 'center'}
          onClick={() => toggleValues({ textAlign: 'center' })}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip offset="xxs" placement="top" content="Align Right">
        <ButtonIcon
          disabled={disabled}
          size="small"
          icon={TextRightIcon}
          active={css.textAlign === 'right'}
          onClick={() => toggleValues({ textAlign: 'right' })}
          radius="small"
          color="white"
        />
      </Tooltip>
    </>
  );
};
